import React, {Component} from 'react';
import Header from "../header";
import Footer from "../footer";
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import {NavLink} from 'react-router-dom';
import Toggle from 'material-ui/Toggle';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import DashboardDetail from "./dashboard-detail";
import { getVisibleOrderDetailFields } from "../constants/order-detail-fields";


class CompanyLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            submitMessage: "",
            isInputChecked: false,
            orders: [],
            ordersdate: [],
            ordersdateError: true,
            selected: [],
            selectedDate: [],
            fulldate: null,
            orderDetailsArr: [],
            orderDetailsReady: false,

            statusOpen: false,
            statusValue: null,
            statusID: null,

            orderTypeSelect: 0,
            orderTypeName: null,
            orderTypeDate: null,
            orderTypeID: null,
        }
    }

    formSubmitClick() {
        let username = document.querySelector('#sUsername').value;
        let pass = document.querySelector('#sPassword').value;

        fetch("https://saydamalbum.com/saydamWebservice/saydamlogin.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "username=" + username
            + "&password=" + pass
        }).then((response) => {
            return response.json();
        }).then((data) => {

            if (data.responseType === 200) { // Eğer giriş yaptıysa
                this.setState({
                    submitMessage: 'Girişiniz başarılı, yönlendiriliyorsunuz..',
                    open: true,
                });

                setTimeout(() => {
                    document.querySelector('#company-login-form').submit()
                }, 2000);

                localStorage.setItem("saydamGiriş", true);
            } else {
                this.setState({
                    submitMessage: "Yanlış kullanıcı adı yada şifre girdiniz.",
                    open: true,
                    isSignIn: false,
                });
            }
        });
    }

    datePickerChange(param1, date) {

        let fulldate = date.getFullYear() + "-" + parseInt(date.getMonth() + 1, 10) + "-" + date.getDate();

        this.setState({
            datePickerValue: date,
            fulldate: fulldate,
        });
        console.log(fulldate);
    }


    getOrders() {
        console.log("ordervalue: " + this.state.orderTypeSelect);

        fetch("https://saydamalbum.com/saydamWebservice/getOrder.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "isDate=" + "false"
            + "&isOrderType=" + this.state.orderTypeSelect
            + "&orderTypeName=" + this.state.orderTypeName
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);
            this.setState({
                orders: data.data,
            })
        });
    }

    handleChange(event, index, value) {
        this.setState({
            statusValue: value,
            statusValueText: event.target.innerText,
        });
    }

    orderTypeHandleChange(event, index, value) {

        this.setState({
            orderTypeSelect: value,
            orderTypeName: event.target.innerText,
        });
    }

    getOrdersDate() {


        fetch("https://saydamalbum.com/saydamWebservice/getOrder.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "isDate=" + true
            + "&date=" + this.state.fulldate
            + "&isOrderType=" + this.state.orderTypeSelect
            + "&orderTypeName=" + this.state.orderTypeName
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);
            if (data.responseType === 200) {
                this.setState({
                    ordersdate: data.data,
                    ordersdateError: false,
                });
            } else {
                this.setState({
                    ordersdateError: true
                })
            }
        });
    }


    isSelected = (index) => {
        return this.state.selected.indexOf(index) !== -1;
    };

    isSelectedDate = (index) => {
        return this.state.selectedDate.indexOf(index) !== -1;
    };


    handleRowSelection = (selectedRows) => {


        if (selectedRows.length === 0) {

        } else {
            let selectedName = this.state.orders[selectedRows].o_orderName;
            let selectedID = this.state.orders[selectedRows].o_orderID;

            this.setState({
                ordersName: this.state.orders[selectedRows].o_orderName,
                selected: selectedRows,
                statusID: selectedID
            });

            fetch("https://saydamalbum.com/saydamWebservice/getOrderDetail.php", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: "orderID=" + selectedID
                + "&orderName=" + selectedName
            }).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data);

                if (data.responseType === 200) {
                    this.setState({
                        orderDetailsArr: data.data,
                        orderDetailsReady: true,
                    })
                }
                console.log(selectedRows);
            });
        }
    };

    handleRowSelectionDate = (selectedRows) => {
        if (selectedRows.length === 0) {

        } else {
            let selectedID = this.state.ordersdate[selectedRows].o_orderID;
            let selectedName = this.state.ordersdate[selectedRows].o_orderName;

            this.setState({
                ordersName: this.state.ordersdate[selectedRows].o_orderName,
                selectedDate: selectedRows,
                statusID: selectedID,
            });

            fetch("https://saydamalbum.com/saydamWebservice/getOrderDetail.php", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: "orderID=" + selectedID
                + "&orderName=" + selectedName
            }).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data);

                if (data.responseType === 200) {
                    this.setState({
                        orderDetailsArr: data.data,
                        orderDetailsReady: true,
                    })
                }
                console.log(selectedRows);
            });
        }

    };

    popupClose() {
        this.setState({
            orderDetailsReady: false,
            statusOpen: false,
        })
    }

    printClicked() {
        let divToPrint = document.getElementById('popupPrint');
        let newWin = window.open('', 'Print-Window');
        const printStyles = [
            'body { font-family: Arial, sans-serif; margin: 20px; }',
            'ul { padding: 0; margin: 0; }',
            'li { list-style: none; border-bottom: 1px solid #e6e6e6; padding: 10px 0; }',
            'strong { font-size: 12px; color: #4a4a4a; width: 150px; display: inline-block; vertical-align: top; }',
            'small { font-size: 14px; font-weight: 600; }',
            '.order-cover-print-image { display: block; max-width: 280px; max-height: 280px; margin-top: 10px; border: 1px solid #ddd; border-radius: 4px; }',
            '@media print { .order-cover-print-image { max-width: 240px; max-height: 240px; page-break-inside: avoid; } }',
        ].join('');

        newWin.document.open();
        newWin.document.write(
            '<html><head><title>Sipariş Detayları</title>'
            + '<style>' + printStyles + '</style>'
            + '</head><body onload="window.print()">'
            + divToPrint.innerHTML
            + '</body></html>'
        );
        newWin.document.close();
        setTimeout(function () {
            newWin.close();
        }, 10);
    }

    statusChange() {
        this.setState({
            statusOpen: true,
        })
    }

    statusFormSubmit(e) {
        e.preventDefault();

        fetch("https://saydamalbum.com/saydamWebservice/orderUpdate.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "status=" + this.state.statusValueText
            + "&statusID=" + this.state.statusID
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);

            this.setState({
                open: true,
                submitMessage: data.responseMessage,
            });

            if (data.responseType === 200) {

            }
        })
    }


    snackbarClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        const row = (item, key) =>
            <TableRow key={key} selected={this.isSelected(key)}>
                <TableRowColumn title={item.o_orderID}> #{item.o_orderID} </TableRowColumn>
                <TableRowColumn title={item.o_orderDate}> {item.o_orderDate}</TableRowColumn>
                <TableRowColumn title={item.o_orderName}> {item.o_orderName}</TableRowColumn>
                <TableRowColumn title={item.o_companyName}> {item.o_companyName}</TableRowColumn>
                <TableRowColumn title={item.o_companyMail}> {item.o_companyMail}</TableRowColumn>
                <TableRowColumn title={item.o_orderStatus}> {item.o_orderStatus}</TableRowColumn>
            </TableRow>;

        const rowsdate = (item, key) =>
            <TableRow key={key} selected={this.isSelectedDate(key)}>
                <TableRowColumn title={item.o_orderID}> #{item.o_orderID} </TableRowColumn>
                <TableRowColumn title={item.o_orderDate}> {item.o_orderDate}</TableRowColumn>
                <TableRowColumn title={item.o_orderName}>{ item.o_orderName}</TableRowColumn>
                <TableRowColumn title={item.o_companyName}> {item.o_companyName}</TableRowColumn>
                <TableRowColumn title={item.o_companyMail}> {item.o_companyMail}</TableRowColumn>
                <TableRowColumn title={item.o_orderStatus}> {item.o_orderStatus}</TableRowColumn>
            </TableRow>;

        return (
            <div>
                <main className="companyLogin">
                    {localStorage.getItem('saydamGiriş') ? (
                        <div className="dashboard">
                            <div className="title">
                                <h1> Saydam Pazarlama | Websitesi Yönetim Paneli </h1>
                            </div>

                            <div className="container">
                                <div className="dashboard-content">
                                    <div className="dashboard-top">

                                        <div className="toggled">
                                            <Toggle
                                                label="Sipariş Tarihini Belirle"
                                                onToggle={(e, inputChecked) => this.setState({isInputChecked: inputChecked})}
                                            />
                                        </div>

                                        <form className="input-group">
                                            {!this.state.isInputChecked ? (
                                                <div>
                                                    <div className="select-type">
                                                        <SelectField
                                                            floatingLabelText="Sipariş Türünü Seç"
                                                            value={this.state.orderTypeSelect}
                                                            onChange={this.orderTypeHandleChange.bind(this)}
                                                        >
                                                            <MenuItem value={0} primaryText="Seçim Zorunlu Değil"/>
                                                            <MenuItem value={1} primaryText="Panoramik Albüm"/>
                                                            <MenuItem value={2} primaryText="Okul Albüm"/>
                                                            <MenuItem value={3} primaryText="Tual"/>
                                                            <MenuItem value={4} primaryText="Fotoblok"/>
                                                            <MenuItem value={5} primaryText="Baskı"/>
                                                        </SelectField>
                                                    </div>

                                                    <RaisedButton
                                                        label="Son Siparişleri Getir"
                                                        primary={true}
                                                        type="button"
                                                        onClick={this.getOrders.bind(this)}
                                                    />
                                                </div>
                                            ) : (
                                                <div>
                                                    <DatePicker
                                                        hintText="Tarihi Giriniz.."
                                                        firstDayOfWeek={0}
                                                        locale='tr-TR'
                                                        okLabel="Tamam"
                                                        cancelLabel="İptal"
                                                        autoOk="true"
                                                        onChange={this.datePickerChange.bind(this)}
                                                        DateTimeFormat={ Intl.DateTimeFormat}
                                                    />

                                                    <div className="select-type">
                                                        <SelectField
                                                            floatingLabelText="Sipariş Türünü Seç"
                                                            value={this.state.orderTypeSelect}
                                                            onChange={this.orderTypeHandleChange.bind(this)}
                                                        >
                                                            <MenuItem value={0} primaryText="Seçim Zorunlu Değil"/>
                                                            <MenuItem value={1} primaryText="Panoramik Albüm"/>
                                                            <MenuItem value={2} primaryText="Okul Albüm"/>
                                                            <MenuItem value={3} primaryText="Tual"/>
                                                            <MenuItem value={4} primaryText="Fotoblok"/>
                                                            <MenuItem value={5} primaryText="Baskı"/>
                                                        </SelectField>
                                                    </div>

                                                    <RaisedButton
                                                        label="Siparişleri Getir"
                                                        primary={true}
                                                        type="button"
                                                        onClick={this.getOrdersDate.bind(this)}
                                                    />
                                                </div>
                                            )}
                                        </form>
                                    </div>

                                    <div className="dashboard-middle">
                                        {!this.state.isInputChecked ? (
                                            <Table onRowSelection={this.handleRowSelection}>
                                                <TableHeader adjustForCheckbox={false} displaySelectAll={false}
                                                             fixedHeader={true}>
                                                    <TableRow>
                                                        <TableHeaderColumn> Sipariş Numarası </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Tarihi </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Türü </TableHeaderColumn>
                                                        <TableHeaderColumn> Firma İsmi </TableHeaderColumn>
                                                        <TableHeaderColumn> Firma Mail </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Durumu </TableHeaderColumn>
                                                    </TableRow>
                                                </TableHeader>
                                                <TableBody
                                                    deselectOnClickaway={false}
                                                    displayRowCheckbox={false}
                                                    rowNumber={true}
                                                >
                                                    {this.state.orders.map((item, key) => row(item, key))}
                                                </TableBody>
                                            </Table>
                                        ) : (
                                            <Table onRowSelection={this.handleRowSelectionDate}>
                                                <TableHeader adjustForCheckbox={false} displaySelectAll={false}
                                                             fixedHeader={true}>
                                                    <TableRow>
                                                        <TableHeaderColumn> Sipariş Numarası </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Tarihi </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Türü </TableHeaderColumn>
                                                        <TableHeaderColumn> Firma İsmi </TableHeaderColumn>
                                                        <TableHeaderColumn> Firma Mail </TableHeaderColumn>
                                                        <TableHeaderColumn> Sipariş Durumu </TableHeaderColumn>
                                                    </TableRow>
                                                </TableHeader>
                                                <TableBody
                                                    deselectOnClickaway={false}
                                                    displayRowCheckbox={false}
                                                    rowNumber={true}
                                                >
                                                    {(this.state.ordersdateError && this.state.ordersdate.length > 0) ? (
                                                        <p className="error">
                                                            Ne yazık ki belirttiğiniz tarihte sipariş görünmüyor.
                                                        </p>
                                                    ) : (
                                                        this.state.ordersdate.map((item, key) => rowsdate(item, key))
                                                    )}
                                                </TableBody>
                                            </Table>
                                        )}
                                    </div>

                                    {(this.state.orderDetailsReady) ? (
                                        <div className="custom-table-popup">
                                            <div className="popup-background"></div>
                                            <div className="popup-content">
                                                <div className="popup-title">
                                                    <h3> Sipariş Detayları </h3>
                                                    <i className="material-icons" onClick={this.popupClose.bind(this)}>
                                                        close </i>
                                                </div>
                                                <div className="popup-list">
                                                    <ul id="popupPrint">
                                                        { getVisibleOrderDetailFields(this.state.ordersName, this.state.orderDetailsArr)
                                                            .map((field) => (
                                                            <DashboardDetail
                                                                el={field.key}
                                                                label={field.label}
                                                                orders={this.state.orderDetailsArr}
                                                                key={field.key}
                                                            />
                                                        ))}

                                                        {this.state.statusOpen ? (
                                                            <li>
                                                                <strong>Sipariş Durumu:</strong>
                                                                <small>
                                                                    <form onSubmit={this.statusFormSubmit.bind(this)}>
                                                                        <SelectField
                                                                            floatingLabelText="Sipariş Durumu"
                                                                            value={this.state.statusValue}
                                                                            onChange={this.handleChange.bind(this)}
                                                                        >
                                                                            <MenuItem value={1}
                                                                                      primaryText="Siparişiniz Hazırlanıyor"/>
                                                                            <MenuItem value={2}
                                                                                      primaryText="Siparişiniz Baskıya Verildi"/>
                                                                            <MenuItem value={3}
                                                                                      primaryText="Siparişiniz Hazır"/>
                                                                        </SelectField>

                                                                        <RaisedButton
                                                                            label="Kaydet"
                                                                            primary={true}
                                                                            type="submit"
                                                                        />
                                                                    </form>
                                                                </small>
                                                            </li>
                                                        ) : (
                                                            <span hidden> </span>
                                                        )}
                                                    </ul>

                                                    <div className="text-right">
                                                        <RaisedButton
                                                            label="Durumu Değiştir"
                                                            primary={true}
                                                            onClick={this.statusChange.bind(this)}
                                                        />

                                                        <RaisedButton
                                                            label="Yazdır"
                                                            secondary={true}
                                                            onClick={this.printClicked.bind(this)}
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <span></span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container">
                            <form id="company-login-form">
                                <h4> Saydampazarlama Giriş </h4>

                                <div className="form-content">
                                    <TextField
                                        id="sUsername"
                                        floatingLabelText="Kullanıcı Adınız"
                                        type="text"
                                        fullWidth={true}
                                    />

                                    <TextField
                                        id="sPassword"
                                        floatingLabelText="Parolanız"
                                        type="password"
                                        fullWidth={true}
                                    />

                                    <div className="buttonDiv">
                                        <RaisedButton
                                            label="Giriş Yap"
                                            labelPosition="before"
                                            icon={<i className="material-icons">send</i>}
                                            backgroundColor="#2c3e50"
                                            color="#fff"
                                            type="button"
                                            onClick={this.formSubmitClick.bind(this)}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </main>

                <Snackbar
                    open={this.state.open}
                    message={this.state.submitMessage}
                    autoHideDuration={2000}
                    onRequestClose={this.snackbarClose}
                />

            </div>
        );
    }
}

export default CompanyLogin;